<template>
  <div class="verval">
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <h1 class="headline info--text"> <strong>Kelola</strong> Penilaian Pelatihan Pengimbasan </h1>
            <div>
              Modul ini digunakan untuk melakukan Kelola Penilaian Pelatihan Pengimbasan Sekolah Penggerak
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card flat>
      <v-card-title class="pa-0">
        <base-table-header
          outlined-button
          @download="onDownloadList"
          @filter="onFilter"
          @search="onSearch"
          @reload="onReload"
        >
          <template v-slot:subtitle>
            <div class="body-1 black--text">
              Jumlah Data <span class="blue--text font-weight-medium">{{ total }}</span>
            </div>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-0">
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list>
                <v-list-item class="px-0">
                  <v-list-item-avatar color="secondary">
                    <v-icon dark>mdi-google-classroom</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-row>
                      <v-col cols="12" md="5">
                        <v-label color="caption"><small>Kelas</small></v-label>
                        <div class="text-body-1 font-weight-medium">{{ item.nama }}</div>
                        <div class="caption" v-if="item.wkt_mulai || item.wkt_selesai">
                          <span class="grey--text text--darken-1">Jadwal:</span>
                          {{
                            item.wkt_mulai && item.wkt_selesai
                              ? $durasi(item.wkt_mulai, item.wkt_selesai)
                              : $localDate(item.wkt_mulai || item.wkt_selesai)
                          }}
                        </div>
                      </v-col>
                      <v-col class="my-auto" cols="12" md="4">
                        <v-label color="caption"><small>Lokasi</small></v-label>
                        <div class="mt-1">{{ item.lokasi }}</div>
                        <div>
                          {{ $getDeepObj(item, 'm_kota.keterangan') }}
                          <span v-if="item.k_propinsi"> - {{ $getDeepObj(item, 'm_propinsi.keterangan') }}</span>
                        </div>
                      </v-col>
                      <v-col class="my-auto" cols="12" md="2">
                        <v-label color="caption"><small>Aksi</small></v-label>
                        <div class="mt-1">
                          <v-btn color="info" small class="text-capitalize" depressed @click="onNilai(item)">
                            Detail Kelas
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" :allow="!allow" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import list from '@mixins/list';
export default {
  name: 'Index',
  components: {},
  mixins: [list],
  data() {
    return {
      formulir: {},
    };
  },
  computed: {
    mGelombang() {
      return [{ text: 'Gelombang 1', value: 1 }];
    },
  },
  created() {
    this.params.gelombang = 1;
  },
  methods: {
    ...mapActions('pengimbasanNilai', ['fetch']),

    onNilai(item) {
      this.$router.push({ name: 'pengimbasan-nilai-peserta', params: { kelas_id: item.psp_pelatihan_kelas_id } });
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
